import "./boot.ts";

import * as React from "react";
import { render } from "react-dom";

import { App, AppProps } from "./App";

const props: AppProps = {
    hasMap: !!window.markers,
    markers: window.markers,
    around: window.around,
    couldNotResolveLocation: window.couldNotResolveLocation,

    hasSearch: !!window.searchContext,
    searchContext: window.searchContext,

    hasNewsSidebar: !!window.categories,
    newsCategories: window.categories,

    hasMedia: !!window.media,
    media: window.media,

    cookieConsent: window.cookieConfig.preferences
};

render(<App {...props} />, document.getElementById("react-entry-point"));
